import { Role } from "../../../helpers/role";
export const FinanceMenu = [
  {
    title: "Payslip Sender",
    icon: "mdi-receipt-text-send",
    to: "payslip-sender",
    code: "payslip-sender",
    role: [Role.Finance],
  },

  {
    title: "Payment Validator",
    icon: "mdi-account-credit-card",
    to: "online-payment-validator",
    code: "online-payment-validator",
    role: [Role.Finance],
  },
];
